import { compact } from 'lodash'

import settingsUtils from 'utils/settings'

/**
 * Prepares settings data for submission based on the given parameters.
 *
 * @param {Object} values - The settings object.
 * @param {Object} initialValues - The initial settings object.
 * @param {String} venueUuid - The venue uuid.
 *
 * @returns {Array} The settings data to send.
 *
 * @description
 * - When creating or updating tip configuration settings, all tip configuration settings need to be sent,
 *   including those that have not been changed.
 * - If `provide_tip_suggestions` is false, tip configuration settings should be filtered out from the final settings.
 *
 */
export const getPreparedSettingsData = (
  values,
  initialValues,
  venueUuid
) => {
  // generate venue settings to send after processing
  const processedVenueSettings =
    settingsUtils.renderFieldsToCreateSettings(
      values,
      initialValues,
      venueUuid
    )

  const processedSettingNames = processedVenueSettings.map(
    (setting) => setting.name
  )

  // prepare default tip configuration settings to send
  const settingsWithDefaultTipConfigurationSettings =
    settingsUtils.prepareDefaultTipConfigurationsToSend(
      initialValues,
      processedSettingNames,
      venueUuid
    )

  // total settings with removed null values from tip_values
  const totalSettings = [
    ...processedVenueSettings,
    ...settingsWithDefaultTipConfigurationSettings,
  ].map((setting) => {
    if (setting.name === 'tip_values') {
      return {
        ...setting,
        value: compact(setting.value),
      }
    }
    return setting
  })

  return totalSettings
}
